import { defineRouting } from 'next-intl/routing'

export type Locale = (typeof routing.locales)[number]

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ['en', 'uz', 'ru', 'kk', 'zh', 'az'],

  // Used when no locale matches
  defaultLocale: 'ru',
  localePrefix: 'as-needed',
  localeDetection: false,
})
